import React, { useState } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import AdxInfoModal from 'components/reusable/modal/AdxInfoModal'
import { useMutation, useQueryClient } from 'react-query'
import { getWithdrawReport, postSubmitReport } from 'services/api/modules/claim/report'
import AdxButton from 'components/custom/AdxButton'

const SubmitReportBar = ({
  totalAmount,
  totalReimbursed,
  reportID,
  handleReportClose,
  isSubmit,
  isReimbursed,
}) => {
  const [isSubmitModalOpen, setSubmitModalOpen] = useState(false)
  const [isErrorModalOpen, setErrorModalOpen] = useState(false)
  const [isSuccessModalOpen, setSuccessModalOpen] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const handleSubmitOpen = () => {
    setSubmitModalOpen(true)
  }
  const handleSubmitClose = () => {
    setSubmitModalOpen(false)
  }
  const handleSuccessOpen = () => {
    setSuccessModalOpen(true)
  }
  const handleSuccessClose = async () => {
    await queryClient.invalidateQueries('singleReportData')
    await queryClient.invalidateQueries('unsubmittedReportsData')
    await queryClient.invalidateQueries('pendingApproverReportsData')
    setSuccessModalOpen(false)
  }
  const handleSuccessBack = async () => {
    await queryClient.invalidateQueries('singleReportData')
    await queryClient.invalidateQueries('unsubmittedReportsData')
    await queryClient.invalidateQueries('pendingApproverReportsData')
    handleSuccessClose()
    handleReportClose()
  }
  const handleErrorOpen = () => {
    setErrorModalOpen(true)
  }
  const handleErrorClose = () => {
    setErrorModalOpen(false)
  }

  // report submission API
  const queryClient = useQueryClient()
  const {
    isLoading: submitLoading,
    error: submitError,
    mutate: submitMutate,
  } = useMutation((reportId) => postSubmitReport(reportId), {
    onSuccess: () => {
      handleSubmitClose()
      handleSuccessOpen()
    },
    onError: async (error) => {
      setErrorMessage(error?.data?.message)
      handleSubmitClose()
      handleErrorOpen()
    },
  })
  const handleReportSubmit = () => {
    submitMutate(reportID)
  }

  // report withdraw
  const {
    isLoading: withdrawLoading,
    error: withdrawError,
    mutate: withdrawMutate,
  } = useMutation((reportId) => getWithdrawReport(reportId), {
    onSuccess: () => {
      queryClient.invalidateQueries('singleReportData')
      queryClient.invalidateQueries('unsubmittedReportsData')
      queryClient.invalidateQueries('pendingApproverReportsData')
      handleSubmitClose()
    },
    onError: async (error) => {
      setErrorMessage(error?.data?.message)
      handleSubmitClose()
      handleErrorOpen()
    },
  })
  const handleReportWithdraw = () => {
    withdrawMutate(reportID)
  }
  return (
    <>
      {/* SUBMISSION MODAL */}
      <AdxInfoModal
        open={isSubmitModalOpen}
        onClose={handleSubmitClose}
        handleClose={handleSubmitClose}
        muiIcon={'question_mark'}
        iconColor="alternate.main"
        title={isSubmit ? 'Confirm submission?' : 'Are you sure you want to withdraw your claim?'}
        subtitle={null}
        footerButtons
        firstBtnLabel={isSubmit ? 'Submit report' : 'Withdraw report'}
        firstBtnHandle={isSubmit ? handleReportSubmit : handleReportWithdraw}
        secondBtnLabel="Cancel"
        secondBtnHandle={handleSubmitClose}
      >
        {/* <AdxButton
          fullWidth
          onClick={isSubmit ? handleReportSubmit : handleReportWithdraw}
        >
          {isSubmit ? 'Submit report' : 'Withdraw report'}
        </AdxButton>
        <AdxButton variant={'ghost'} fullWidth onClick={handleSubmitClose}>
          Cancel
        </AdxButton> */}
      </AdxInfoModal>

      {/* SUCCESS MODAL */}
      <AdxInfoModal
        open={isSuccessModalOpen}
        onClose={(_, reason) => {
          if (reason !== 'backdropClick') {
            handleSuccessClose()
          }
        }}
        handleClose={handleSuccessClose}
        muiIcon="error"
        iconColor="alternate.main"
        title="Report submitted"
        subtitle="Sucess!"
        footerButtons
        firstBtnLabel="Return to all reports"
        firstBtnHandle={handleSuccessBack}
        secondBtnLabel="Okay"
        secondBtnHandle={handleSuccessClose}
      >
        {/* <AdxButton color="alternate" fullWidth onClick={handleSuccessBack}>
          Return to all reports
        </AdxButton>
        <AdxButton variant={'ghost'} fullWidth onClick={handleSuccessClose}>
          Ok
        </AdxButton> */}
      </AdxInfoModal>

      {/* ERROR MODAL */}
      <AdxInfoModal
        variant="error"
        open={isErrorModalOpen}
        onClose={(_, reason) => {
          if (reason !== 'backdropClick') {
            handleErrorClose()
          }
        }}
        handleClose={handleErrorClose}
        muiIcon="error"
        iconColor="error.main"
        title="An error occured"
        subtitle={errorMessage}
        footerButtons
        firstBtnLabel="Cancel"
        firstBtnHandle={handleErrorClose}
      >
        {/* <AdxButton
          color="error"
          fullWidth
          onClick={handleErrorClose}
          sx={{
            '&:hover': {
              backgroundColor: 'error.main',
            },
          }}
        >
          Cancel
        </AdxButton> */}
      </AdxInfoModal>
      <Box
        display="flex"
        flexDirection={{ xs: 'column', lg: 'row' }}
        alignItems="center"
        justifyContent={{ xs: 'center', lg: 'space-between' }}
        columnGap={{ xs: 0, lg: 4 }}
        rowGap={{ xs: 2, lg: 0 }}
        width={1}
        height={{ xs: 'auto', lg: 100 }}
        bgcolor="warning.light"
        position={{ xs: 'fixed', lg: 'absolute' }}
        bottom={0}
        left={0}
        boxSizing="border-box"
        paddingX={{ xs: 2, lg: 4 }}
        paddingBottom={{ xs: 4, lg: 0 }}
        paddingTop={{ xs: 3, lg: 0 }}
        zIndex={49}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          columnGap={1}
          width={{ xs: 1, lg: isReimbursed ? 1 : 'calc(100% - 450px)' }}
        >
          <Typography color="" variant="h4">
            {isReimbursed ? 'Total Reimbursement' : 'Total Expense'}
          </Typography>
          <Typography color="" variant="h4" fontWeight="bold">
            RM {isReimbursed ? totalReimbursed : totalAmount}
          </Typography>
        </Box>
        {!isReimbursed && (
          <AdxButton
            variant={''}
            onClick={handleSubmitOpen}
            sx={{
              width: { xs: 1, md: '400px' },
            }}
          >
            {isSubmit ? 'Submit claim' : 'Withdraw report'}
          </AdxButton>
        )}
      </Box>
    </>
  )
}

export default SubmitReportBar
